<template>
  <ModalDialog
    ref="dialog"
    title="Reroute Production"
    :submitting="submitting"
    submitTitle="Update"
    :submitDisabled="submitDisabled"
    icon="fa-exchange"
    @closed="onClosed"
    @submitted="onSubmitted">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />
    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <NotificationBar type="info">
        <NotificationBarTitle>This will route the selected panels to different station(s) at a location</NotificationBarTitle>
        <ul>
          <li>If the station is at a different location, the panels will require transfers</li>
          <li>When panels have specific stations set for the {{productionStage.name}} stage, they cannot be scanned in elsewhere for the stage</li>
        </ul>
      </NotificationBar>
      <FormRow label="Info">
        <FormStaticLabel>Route {{panelIdList.length}} Panels at {{productionStage.name}} stage</FormStaticLabel>
      </FormRow>

      <FormRow label="Destination Station">
        <FormMultiSelect :options="stationLookup" v-model="destinationStationIdList" placeholder="Select the destination station" field="productionStationList" />
      </FormRow>
            
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'
import ProductionMixin from '@/modules/production/mixins/production'

export default {
  name: 'ProductionManagerRerouteDialog',
  mixins: [
    modalDialog,
    form,
    ProductionMixin
  ],
  components: {
    ModalDialog
  },
  props: {
    productionStage: Object,
    panelIdList: Array    
  },
  data() {
    return {
      dialogForm: {},
      loadingError: '',
      productionStationList: [],
      destinationStationIdList: [],
      loading: false,
      submitting: false
    }
  },
  created() {
  },
  mounted() {
    this.requestData()
  },
  computed: {
    stationLookup() {
      return this.productionStationList.map(station => {
        return {
          value: station.id,
          name: `${station.name} - ${station.accountLocation ? station.accountLocation.name : 'Unknown Location'}`
        }
      })
    },
    submitDisabled() {
      if(this.destinationStationIdList.length == 0 || !this.panelIdList || this.panelIdList.length == 0)
        return true
      return false
    } 
  },
  methods: {
    show() {
      this.dialogForm = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.submitting = true
      this.dialogForm = this.clearFormResponse()

      var updateData = {
        productionPanelList: this.panelIdList,
        productionStageId: this.productionStage.id,
        productionStationList: this.destinationStationIdList
      }

      this.$apiService.productionService.routeProductionPanel(updateData)
      .then(response => {
        this.submitting = false
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    },

    requestData() {
      this.loading = true
      this.loadingError = ''

      // Load station list
      this.$apiService.productionService.getProductionStationList()
      .then(response => {
        this.productionStationList = response.data.filter(station => {
          if(!station.isActive || !this.isProductionStationPrimaryType(station.type))
            return false

          return station.productionStages.some(stage => stage.id == this.productionStage.id)
        })
       
      })
      .catch(err => {
        this.loadingError = 'Error accessing data. Please check your internet connection and try again'
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>